import { Notification } from 'models/Notification';
import { baseService } from '../baseService';
import HttpClient from '../../services/HttpClient';

const baseUrl = '/notifications';

export const getNotifications = baseService<undefined, Notification[]>(() =>
  HttpClient.get(baseUrl),
);
